// extracted by mini-css-extract-plugin
export default {"table":"ShelfTable_table__CxFN2","addButton":"ShelfTable_addButton__phGma","searchField":"ShelfTable_searchField__blFRq","emptyRow":"ShelfTable_emptyRow__AyAF3"};